import { Box, styled } from "@mui/material";
import Button from "../../../Button";

export const StyledDayCalendar = styled(Box)`
  width: calc(${(props) => props.theme.wsc.size.xxl} * 8);
  margin: 0 auto;
  display: flex;
  gap: ${(props) => props.theme.wsc.spacing[0]};
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledWeekdayCalendar = styled(StyledDayCalendar)`
  row-gap: ${(props) => props.theme.wsc.spacing[2]};
  column-gap: ${(props) => props.theme.wsc.spacing[3]};
`;

export const StyledDayButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{
  isSelected?: boolean;
}>`
  &.MuiButton-root {
    min-width: ${(props) => props.theme.wsc.size.xxl};
    width: ${(props) => props.theme.wsc.size.xxl};
    height: ${(props) => props.theme.wsc.size.xxl};
    border-radius: ${(props) => props.theme.wsc.radius.half};
    ${(props) => props.theme.wsc.typography.header5};
    outline: none;

    ${(props) =>
      props.isSelected
        ? `
			&, &:hover, &:focus {
				color: ${props.theme.wsc.palette.neutral[800]};
				background-color: ${props.theme.wsc.palette.primary[300]};
			}
		`
        : `
			background: none;
			color: ${props.theme.wsc.palette.neutral[100]};
			
			&:hover {
				background-color: ${props.theme.wsc.palette.neutral[600]};
			}
			
			&:focus {
				color: ${props.theme.wsc.palette.neutral[100]};
				background-color: none;
			}
		`}

    &.Mui-disabled {
      color: ${(props) => props.theme.wsc.palette.neutral[400]};
    }
  }
`;

export const StyledWeekdayButton = styled(StyledDayButton)`
  &.MuiButton-root {
    width: calc(${(props) => props.theme.wsc.size.m} * 4);
    height: ${(props) => props.theme.wsc.size.xxl};
    padding: 0;
    border-radius: ${(props) => props.theme.wsc.radius.xxl};
  }
`;

export const StyledSwitchButton = styled(Button)`
  &.MuiButton-root {
    background: none;
    color: ${(props) => props.theme.wsc.palette.neutral[100]};

    &:hover {
      background: ${(props) => props.theme.wsc.palette.neutral[600]};
    }

    &:active {
      color: ${(props) => props.theme.wsc.palette.primary[500]};
      background: ${(props) => props.theme.wsc.palette.neutral[600]};
    }
  }
`;
